import { Link } from "@tanstack/react-router";
import { Mail, ShieldCheck } from "lucide-react";
import { Wordmark } from "@/components/Wordmark";
import { SupportLinkTrigger } from "@/components/SupportTrigger";

import { COIN_PRICE_CENTS, formatEuro } from "@/lib/salonturbo";

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t bg-secondary/40">
      <div className="mx-auto max-w-6xl px-4 py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex min-w-0 items-center">
              <Wordmark />
            </Link>

            <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground">
              Tagesaktuelle Sichtbarkeit für Friseursalons: Tag auswählen, Coin einlösen – lokale
              Suchanzeigen laufen automatisch. Ohne Agentur, ohne Mindestlaufzeit.
            </p>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
              Themen
            </h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/preise" className="text-muted-foreground hover:text-foreground">
                  Preise
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-foreground">
                  Häufige Fragen
                </Link>
              </li>
              <li>
                <Link to="/friseur-werbung" className="text-muted-foreground hover:text-foreground">
                  Friseur-Werbung
                </Link>
              </li>
              <li>
                <Link
                  to="/friseur-termin-heute"
                  className="text-muted-foreground hover:text-foreground"
                >
                  Friseurtermin heute
                </Link>
              </li>
              <li>
                <Link to="/guide" className="text-muted-foreground hover:text-foreground">
                  Gratis-Guide
                </Link>
              </li>
              <li>
                <Link to="/ablauf" className="text-muted-foreground hover:text-foreground">
                  So funktioniert SalonTurbo
                </Link>
              </li>

            </ul>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
              Account & Hilfe
            </h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/auth" className="text-muted-foreground hover:text-foreground">
                  Registrieren
                </Link>
              </li>
              <li>
                <Link to="/auth" className="text-muted-foreground hover:text-foreground">
                  Login
                </Link>
              </li>
              <li>
                <SupportLinkTrigger
                  label="Support kontaktieren"
                  className="text-muted-foreground hover:text-foreground"
                />
              </li>
              <li className="flex items-center gap-2 text-muted-foreground">
                <Mail className="size-4 shrink-0" />
                <a href="mailto:hallo@salonturbo.de" className="hover:text-foreground">
                  hallo@salonturbo.de
                </a>
              </li>
            </ul>

          </div>
        </div>

        <div className="mt-10 rounded-2xl border bg-secondary/30 p-5 sm:p-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <div className="flex size-10 items-center justify-center rounded-full bg-primary/10">
                <ShieldCheck className="size-5 text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium">Sicher & bequem bezahlen</p>
                <p className="text-xs text-muted-foreground">
                  Von Stripe abgewickelt. SSL-verschlüsselt.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {[
                { src: "/payment/visa.svg", alt: "Visa", h: "h-4" },
                { src: "/payment/mastercard.svg", alt: "Mastercard", h: "h-5" },
                { src: "/payment/applepay.svg", alt: "Apple Pay", h: "h-4" },
                { src: "/payment/googlepay.svg", alt: "Google Pay", h: "h-4" },
              ].map((brand) => (
                <span
                  key={brand.alt}
                  className="inline-flex h-9 items-center rounded-lg border bg-background px-3"
                >
                  <img
                    src={brand.src}
                    alt={`${brand.alt} Logo`}
                    loading="lazy"
                    className={`${brand.h} w-auto object-contain`}
                  />
                </span>
              ))}
              <span className="inline-flex h-9 items-center rounded-lg border bg-background px-3 text-xs font-semibold tracking-wide">
                SEPA
              </span>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} SalonTurbo</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <a
              href="https://swax-media.de/impressum"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              Impressum
            </a>
            <a
              href="https://swax-media.de/datenschutzerklaerung"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground"
            >
              Datenschutzerklärung
            </a>
            <Link to="/agb" className="hover:text-foreground">
              AGB
            </Link>
          </div>
          <p>1 Coin = {formatEuro(COIN_PRICE_CENTS)} netto zzgl. MwSt. = 1 Boost-Tag</p>
        </div>
      </div>
    </footer>
  );
}

